import { useState } from 'react';
import { Position } from 'reactflow';
import { BaseNode, NodeField, NodeInput, NodeSelect } from './baseNode';

export const ApiNode = ({ id, data }) => {
  const [method, setMethod] = useState(data?.method || 'GET');
  const [url, setUrl] = useState(data?.url || '');
  const [authType, setAuthType] = useState(data?.authType || 'None');

  const handles = [
    { type: 'target', position: Position.Left,  id: `${id}-body`,    style: { top: '40%' } },
    { type: 'target', position: Position.Left,  id: `${id}-headers`, style: { top: '70%' } },
    { type: 'source', position: Position.Right, id: `${id}-response`,style: { top: '81%' } },
    { type: 'source', position: Position.Right, id: `${id}-error`,   style: { top: '93%' } },
  ];

  const methodColors = { GET: '#16a34a', POST: '#2563eb', PUT: '#d97706', DELETE: '#dc2626' };

  return (
    <BaseNode label="API Call" color="#06b6d4" handles={handles} width={240}>
      <div style={{ display: 'flex', gap: 6 }}>
        <div style={{ width: 70 }}>
          <div style={{ fontSize: 10, fontWeight: 600, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 2 }}>Method</div>
          <NodeSelect value={method} onChange={e => setMethod(e.target.value)}
            style={{ color: methodColors[method] || '#1e293b', fontWeight: 700 }}>
            <option value="GET">GET</option>
            <option value="POST">POST</option>
            <option value="PUT">PUT</option>
            <option value="DELETE">DELETE</option>
          </NodeSelect>
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 10, fontWeight: 600, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 2 }}>URL</div>
          <NodeInput value={url} onChange={e => setUrl(e.target.value)} placeholder="https://api.example.com" />
        </div>
      </div>
      <NodeField label="Auth">
        <NodeSelect value={authType} onChange={e => setAuthType(e.target.value)}>
          <option value="None">None</option>
          <option value="Bearer">Bearer Token</option>
          <option value="Basic">Basic Auth</option>
          <option value="API Key">API Key</option>
        </NodeSelect>
      </NodeField>
      
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 4, marginTop: 4, fontSize: 10 }}>
        <span style={{ color: '#16a34a', fontWeight: 600 }}>response →</span>
        <span style={{ color: '#dc2626', fontWeight: 600 }}>error →</span>
      </div>
    </BaseNode>
  );
};